import React, { useEffect, useState } from 'react';
import { OnboardingActions } from '@portal/actions';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import AdvancedForm from '@portal/components/AdvancedForm/AdvancedForm';
import PanelContentHeader from '@portal/components/PanelContentHeader/PanelContentHeader';
import { Input } from 'antd';
import { useDispatch } from 'react-redux';

import useReduxState from '@portal/hooks/useReduxState';
import * as MessageService from '~/services/message';
import { maskCpf, unmaskField } from '@portal/services/masks';
import { ONBOARDING_TAX_ID_STATUS } from '@portal/actions/actionTypes';
import { validateStatus } from '@portal/enum/validateStatus';
import { useNavigation } from '@portal/hooks/useNavigation';

const Register = () => {
  const dispatch = useDispatch();
  const {
    onboarding: { taxIdStatus },
  } = useReduxState();
  const navigate = useNavigation();
  const [taxId, setTaxId] = useState('');

  const handleSubmit = () => {
    if (taxId.length === 14) {
      dispatch(OnboardingActions.validateTaxId(unmaskField(taxId)));
    }
  };

  useEffect(() => {
    if (taxIdStatus) {
      if (taxIdStatus === validateStatus.OK) {
        navigate('/cadastrar-numero');
        dispatch({ type: ONBOARDING_TAX_ID_STATUS, payload: null });
      } else if (taxIdStatus === validateStatus.IN_USE) {
        MessageService.error('CPF/CNPJ ja esta em uso');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taxIdStatus]);

  return (
    <div className="register">
      <PanelContentHeader pageTitle="Cadastrar" />
      <AdvancedForm onSubmit={handleSubmit}>
        <p className="register__text">Precisamos do seu CPF</p>
        <Input
          placeholder="999.999.999-99"
          value={taxId}
          onChange={(e) => setTaxId(maskCpf(e.target.value))}
        />
        <AdvancedButton
          text="Continuar"
          type="submit"
          disabled={taxId.length !== 14}
        />
      </AdvancedForm>
    </div>
  );
};

export default Register;
